import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("InfoPopupWidget", {
  title: "InfoPopup",
  attributes: {
    popupTitle: { title: "Popup title" },
    popupSubtitle: { title: "Popup subtitle" },
    popupContent: { title: "Popup content" },
    popupLink: { title: "Popup Link" },
  },
  properties: ["popupTitle", "popupSubtitle", "popupContent", "popupLink"],
});
